export enum SchoolKindEnum {
  ESchool = 1,
  JSchool = 2
}
